import { Manager, FormFields } from './types';

// Sample data for managers
export const managers: Manager[] = [
  { name: 'Abhinav Krishna Aadiraju', id: 420 },
  { name: 'Priya Sharma', id: 421 },
  { name: 'Rahul Gupta', id: 422 },
  { name: 'Sneha Patel', id: 423 },
];

// Form initial data
export const initialFormData: FormFields = {
  name: '',
  email_id: '',
  email_not_present: false,
  hire_date: null,
  designation: '',
  department: '',
  manager_people_id: null,
  pan: '',
};

export const CREATE_CONTRACTOR = 'CREATE_CONTRACTOR';